import type { TDateArg } from '@/src/general/primitives/dates/date.types'

import type { TStreakItem } from '../streak/streak.type'

type TApplyTodayPrayerProgressToStreakDaysParams = {
  days: TStreakItem[]
  today: TDateArg
  answeredPrayers: number
  totalPrayers: number
}

export const applyTodayPrayerProgressToStreakDays = ({
  days,
  today,
  answeredPrayers,
  totalPrayers,
}: TApplyTodayPrayerProgressToStreakDaysParams): TStreakItem[] => {
  if (totalPrayers === 0 || answeredPrayers >= totalPrayers) {
    return days
  }

  const todayPercentile = Math.round((answeredPrayers / totalPrayers) * 100)

  return days.map((day) => (day.day === today ? { ...day, percentile: todayPercentile } : day))
}
